/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthEmailControllerSendCodeMutationRequest,
  TelegramAuthEmailControllerSendCodeMutationResponse,
  TelegramAuthEmailControllerSendCode400,
  TelegramAuthEmailControllerSendCode401,
  TelegramAuthEmailControllerSendCode403,
  TelegramAuthEmailControllerSendCode429,
} from '../types/TelegramAuthEmailControllerSendCode.ts';

function getTelegramAuthEmailSendCodeUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/email/send-code` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/email/send-code}
 */
export async function telegramAuthEmailSendCode(
  data: TelegramAuthEmailControllerSendCodeMutationRequest,
  config: Partial<RequestConfig<TelegramAuthEmailControllerSendCodeMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthEmailControllerSendCodeMutationResponse,
    ResponseErrorConfig<
      | TelegramAuthEmailControllerSendCode400
      | TelegramAuthEmailControllerSendCode401
      | TelegramAuthEmailControllerSendCode403
      | TelegramAuthEmailControllerSendCode429
    >,
    TelegramAuthEmailControllerSendCodeMutationRequest
  >({ method: 'POST', url: getTelegramAuthEmailSendCodeUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
